import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type RiskAssessment } from '../../api/decision';

export function RiskDashboardPage() {
  const [risks, setRisks] = useState<RiskAssessment[]>([]);

  useEffect(() => {
    void decisionApi.listRisk().then(setRisks);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Risk Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Business, financial, operational and execution risk assessments.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {risks.map((r) => (
          <div key={r.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex justify-between">
              <span className="font-medium capitalize">{r.category}</span>
              <span className={`text-sm ${r.level === 'high' ? 'text-red-600' : r.level === 'medium' ? 'text-amber-600' : 'text-green-600'}`}>{r.level}</span>
            </div>
            <p className="mt-2 text-sm text-slate-500">Score: {(r.score * 100).toFixed(0)}%</p>
            {r.mitigation && <p className="mt-1 text-sm">{r.mitigation}</p>}
          </div>
        ))}
        {risks.length === 0 && <p className="text-sm text-slate-500">No risk assessments yet. Create a decision to generate risk analysis.</p>}
      </div>
    </div>
  );
}
